module.exports = __webpack_public_path__ + "static/img/qcjg2.ee67666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcjg2.png
// module id = 1E0Y
// module chunks = 1